var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15V23M23 31H23.02M19.58 4.72L2.64 33C2.29074 33.6048 2.10593 34.2906 2.10398 34.989C2.10202 35.6875 2.28298 36.3743 2.62885 36.981C2.97472 37.5878 3.47345 38.0935 4.07542 38.4477C4.67738 38.8019 5.3616 38.9923 6.06 39H39.94C40.6384 38.9923 41.3226 38.8019 41.9246 38.4477C42.5265 38.0935 43.0253 37.5878 43.3711 36.981C43.717 36.3743 43.898 35.6875 43.896 34.989C43.8941 34.2906 43.7093 33.6048 43.36 33L26.42 4.72C26.0635 4.13221 25.5614 3.64624 24.9624 3.30897C24.3633 2.97169 23.6875 2.79451 23 2.79451C22.3125 2.79451 21.6367 2.97169 21.0376 3.30897C20.4386 3.64624 19.9365 4.13221 19.58 4.72Z",
    stroke: "#FFA0A0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.ec28295b3b7e20a93da4073d228ceeb7.svg";
export { ForwardRef as ReactComponent };